'use client';

import {
  specialOfferPageIsArrival,
  specialOfferPageIsLoaded,
} from '@wwe-portal/web/libs/analytics/offer';
import { useEffect } from 'react';

export const AnalyticsPageLoad = () => {
  useEffect(() => {
    specialOfferPageIsLoaded();
    specialOfferPageIsArrival();
  }, []);
  return <></>;
};
